'use client';

import { useRouter } from 'next/navigation';
import { RouterProvider } from 'react-aria-components';

import type { PropsWithChildren, JSX } from 'react';

declare module 'react-aria-components' {
  interface RouterConfig {
    routerOptions: NonNullable<
      Parameters<ReturnType<typeof useRouter>['push']>[1]
    >;
  }
}

export function RouteProvider({ children }: PropsWithChildren): JSX.Element {
  const router = useRouter();

  return <RouterProvider navigate={router.push}>{children}</RouterProvider>;
}
